import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import ErrorBoundary from './components/ErrorBoundary';
import AdminLayout from './components/AdminLayout';
import Login from './pages/AdminLogin';
import Dashboard from './pages/Dashboard';
import BooksManager from './pages/BooksManager';
import OrdersManager from './pages/OrdersManager';
import UsersManager from './pages/UsersManager';
import CategoriesManager from './pages/CategoriesManager';
import BannersManager from './pages/BannersManager';
import CouponsManager from './pages/CouponsManager';
import MessagesManager from './pages/MessagesManager';
import BlogManager from './pages/BlogManager';
import ReviewsManager from './pages/ReviewsManager';
import SiteContentManager from './pages/SiteContentManager';
import ReturnsManager from './pages/ReturnsManager';
import ShippingManager from './pages/ShippingManager';
import CountriesManager from './pages/CountriesManager';
import HomeSectionsManager from './pages/HomeSectionsManager';
import PaymentSettingsManager from './pages/PaymentSettingsManager';
import ReturnReasonsManager from './pages/ReturnReasonsManager';
import { AdminToastProvider } from './context/AdminToastContext';
import { AdminConfirmProvider } from './context/AdminConfirmContext';

const App = () => {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <AdminToastProvider>
          <AdminConfirmProvider>
            <Router>
              <Routes>
                <Route path="/login" element={<Login />} />
                <Route path="/" element={<AdminLayout />}>
                  <Route index element={<Dashboard />} />
                  <Route path="books" element={<BooksManager />} />
                  <Route path="orders" element={<OrdersManager />} />
                  <Route path="returns" element={<ReturnsManager />} />
                  <Route path="users" element={<UsersManager />} />
                  <Route path="categories" element={<CategoriesManager />} />
                  <Route path="banners" element={<BannersManager />} />
                  <Route path="coupons" element={<CouponsManager />} />
                  <Route path="blog" element={<BlogManager />} />
                  <Route path="reviews" element={<ReviewsManager />} />
                  <Route path="site-content" element={<SiteContentManager />} />
                  <Route path="home-sections" element={<HomeSectionsManager />} />
                  <Route path="shipping" element={<ShippingManager />} />
                  <Route path="countries" element={<CountriesManager />} />
                  <Route path="messages" element={<MessagesManager />} />
                  <Route path="payment-settings" element={<PaymentSettingsManager />} />
                  <Route path="return-reasons" element={<ReturnReasonsManager />} />
                </Route>
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </Router>
          </AdminConfirmProvider>
        </AdminToastProvider>
      </AuthProvider>
    </ErrorBoundary>
  );
};

export default App;
